var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container mt-3" }, [
    _vm.expectedVerificationCode
      ? _c("p", [_vm._v(_vm._s(_vm.expectedVerificationCode))])
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "hidden", name: "code" },
      domProps: { value: _vm.verificationCode },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("div", { staticClass: "phone-icon-container" }, [
          _c(
            "div",
            { staticClass: "phone-icon" },
            [_c("phone-icon", { attrs: { size: "38" } })],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "p",
            { staticClass: "phone-number-verification-title text-center" },
            [_vm._v(" " + _vm._s(_vm.i18nStrings.title) + " ")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "font-semibold phone-number-verification-description text-center px-2",
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.i18nStrings.description) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "phone-number-verification-timer text-center" },
            [
              _vm._v(
                "\n         " + _vm._s(_vm.formattedCountdown) + " \n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.isError
          ? _c("ui-alert", {
              staticClass: "my-4",
              attrs: {
                type: "warning",
                title: _vm.errorTitle,
                description: _vm.errorMessage,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("input-digits", {
          attrs: { length: 6, value: _vm.verificationCode },
          on: { input: _vm.onInputCode },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "resend-code-form" }, [
          _c(
            "p",
            { staticClass: "text-center" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.i18nStrings.didntReceiveText) +
                  " \n        "
              ),
              _c("ui-button", {
                staticClass: "p-0",
                attrs: {
                  appearance: "primary",
                  "button-type": "blank",
                  disabled: _vm.isCooldownActive,
                  label: _vm.i18nStrings.resendText,
                },
                on: { click: _vm.resendCode },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "verification-footer" },
      [
        _c("ui-button", {
          attrs: {
            appearance: "secondary",
            uppercase: "",
            block: "",
            disabled: _vm.isConfirmButtonDisabled,
            label: _vm.i18nStrings.confirmCodeButton,
          },
          on: { click: _vm.submitCode },
        }),
        _vm._v(" "),
        _c("ui-button", {
          attrs: {
            appearance: "secondary",
            href: _vm.changePhoneNumberUrl,
            "button-type": "blank",
            uppercase: "",
            block: "",
            label: _vm.i18nStrings.changeNumberButton,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }